import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { useFormSlot } from 'components/common/form/layout/control/FormComponentSlot';
import { InfoMessageType, ReIndexRequiredLine } from 'components/common/form/layout/helper/ReIndexRequiredLine';
import { ActAfterSaveSuccess } from 'components/common/form/act';
import useWatchFormFieldsChanges from 'components/common/form/hooks/useWatchFormFieldsChanges';
import useWatchFormGridsChanges from 'components/common/form/hooks/useWatchFormGridsChanges';

export default function SearchForm(props: IFormLayoutProps) {
    const slotComponent = useFormSlot('dShowIndexRequired');
    const [showMessage, setShowMessage] = useState<InfoMessageType>('none');
    const [fields] = useState<Array<string>>(
        props.componentsMap.filter((c) => c.props.component.component != 'GridComponent').map((c) => c.componentName),
    );
    const [formWasSaved, setFormWasSaved] = useState(false);
    useEffect(() => {
        props.hookForm.form.formAct.overrideAct(
            'afterSaveSuccess',
            class extends ActAfterSaveSuccess {
                async exec(response: any, data: any): Promise<any> {
                    setFormWasSaved(true);
                    return super.exec(response, data);
                }
            },
        );
    }, [props.hookForm.form]);

    const resetFields = useWatchFormFieldsChanges(props.hookForm.form, fields, 'fieldsChanged');
    const flag = props.hookForm.form.hookFormWatch('fieldsChanged');
    const { changedGrids, resetChangedGrids } = useWatchFormGridsChanges(props.hookForm.form, [
        'reference_grid',
        'dataset_grid',
        'alias_grid',
    ]);

    useEffect(() => {
        if (changedGrids.length) {
            props.hookForm.form.hookFormSetValue('fieldsChanged', 'Y');
        }
    }, [changedGrids]);

    useEffect(() => {
        if (!formWasSaved) {
            return;
        }

        if (flag == 'Y') {
            setShowMessage('optimized');
        }

        if (flag == '') {
            setShowMessage('none');
            resetFields();
            resetChangedGrids();
            setFormWasSaved(false);
        }
    }, [flag, formWasSaved]);

    return (
        <>
            <FormLayoutComposer props={props} />
            {slotComponent &&
                createPortal(
                    <ReIndexRequiredLine
                        form={props.hookForm.form}
                        messageType={showMessage}
                        resetFields={['fieldsChanged']}
                    />,
                    slotComponent,
                )}
        </>
    );
}
